.panel {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 24px;
  min-width: 0;
}

.heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}

.label {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
  flex-shrink: 0;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px 14px;
  min-width: 0;
}

.legendItem {
  font-size: 0.85rem;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.legendItem::before {
  content: "—  ";
}

.svg {
  display: block;
  width: 100%;
  overflow: visible;
}

.empty {
  display: grid;
  place-items: center;
  min-height: 200px;
  font-size: 0.9rem;
  color: var(--muted);
}

.tooltip {
  position: fixed;
  z-index: 9999;
  background: var(--canvas);
  border: 1px solid var(--border-md);
  border-radius: 8px;
  padding: 8px 12px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 3px;
  box-shadow: 0 6px 20px rgba(38, 33, 25, 0.18);
}

.tooltipDate {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--soft);
}

.tooltipRow {
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
}
